import {Modal, Typography, Button} from 'antd';
import React from 'react';

import {frameworkRoute} from '../constants/frameworkRoutes';

interface ConfirmOverrideModalProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
  framework: string;
}

const ConfirmOverrideModal: React.FC<ConfirmOverrideModalProps> = ({
  open,
  onConfirm,
  onCancel,
  loading = false,
  framework
}) => {
  return (
    <Modal
      open={open}
      centered
      closable={false}
      footer={null}
      width={500}
      style={{textAlign: 'center'}}
      bodyStyle={{
        padding: '20px 32px',
        borderRadius: 16
      }}
      maskClosable={false}
      zIndex={2000} // ensures it sits above main modal
    >
      <Typography.Text strong style={{fontSize: 18, marginBottom: 8}}>
        Confirm Data Override!
      </Typography.Text>

      <div style={{marginBottom: 32, marginTop: 20}}>
        All the fields shown before will be mapped with data from the{' '}
        {framework === frameworkRoute.BRSR
          ? frameworkRoute.GRI
          : frameworkRoute.BRSR}
        . Are you sure you want to proceed?
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: 20,
          marginTop: 20
        }}
      >
        <Button
          onClick={onConfirm}
          style={{
            backgroundColor: '#1b744f',
            borderRadius: '50px',
            color: '#fff',
            borderColor: '#1b744f',
            padding: '8px 20px',
            height: 'auto',
            fontWeight: 'bold',
            fontSize: '16px'
          }}
          loading={loading}
        >
          Confirm
        </Button>

        <Button
          onClick={onCancel}
          style={{
            backgroundColor: '#003A70',
            borderRadius: '50px',
            color: '#fff',
            borderColor: '#003A70',
            padding: '8px 20px',
            height: 'auto',
            fontWeight: 'bold',
            fontSize: '16px'
          }}
        >
          Cancel
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmOverrideModal;
